import { render, staticRenderFns } from "./InstallationHistoryEntry.vue?vue&type=template&id=20bf6b8c&scoped=true"
import script from "./InstallationHistoryEntry.vue?vue&type=script&lang=js"
export * from "./InstallationHistoryEntry.vue?vue&type=script&lang=js"
import style0 from "./InstallationHistoryEntry.vue?vue&type=style&index=0&id=20bf6b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf6b8c",
  null
  
)

export default component.exports